module.exports = __webpack_public_path__ + "assets/collaboration_primary.12737ac4.svg";